export const LOCALE_PREFIX = 'components.FinanceTable'

// Depends on CSS styles
export const TABLE_COLUMN_WIDTH = 166

export const FINANCE_TABLE_SET_YEAR_BOUNDS = 'FINANCE_TABLE_SET_YEAR_BOUNDS'
export const FINANCE_TABLE_CHANGE_YEAR_BOUNDS = 'FINANCE_TABLE_CHANGE_YEAR_BOUNDS'
export const FINANCE_TABLE_SET_YEARS = 'FINANCE_TABLE_SET_YEARS'
export const FINANCE_TABLE_CHANGE_COMPARE_YEAR = 'FINANCE_TABLE_CHANGE_COMPARE_YEAR'
export const FINANCE_TABLE_CHANGE_SAMPLE_YEAR = 'FINANCE_TABLE_CHANGE_SAMPLE_YEAR'
export const FINANCE_TABLE_ADD_OPEN_ROW = 'FINANCE_TABLE_ADD_OPEN_ROW'
export const FINANCE_TABLE_REMOVE_OPEN_ROWS = 'FINANCE_TABLE_REMOVE_OPEN_ROWS'
export const FINANCE_TABLE_SET_OPEN_ROWS = 'FINANCE_TABLE_SET_OPEN_ROWS'

// Used in data columns to format numbers
export const NUMBER_MAGNITUDES = {
    DEFAULT: {
        translate: null,
        range: [0, 4],
        base: 1,
    },
    THOUSAND: {
        translate: 'thousand',
        range: [4, 7],
        base: 1000,
    },
    MILLION: {
        translate: 'million',
        range: [7, 10],
        base: 1000000,
    },
    BILLION: {
        translate: 'billion',
        range: [10, 13],
        base: 1000000000,
    },
    TRILLION: {
        translate: 'trillion',
        range: [13, 16],
        base: 1000000000000,
    },
}

// Used in results column, used to set arrow direction
export const TREND = {
    STAGNATION: 'stagnation',
    DECREASE: 'decrease',
    INCREASE: 'increase',
    STEEP_DECREASE: 'steepDecrease',
    STEEP_INCREASE: 'steepIncrease',
}

// Used in results column, used to set arrow color, has to be capitalized
export const POSITIVE = 'Positive'
export const NEGATIVE = 'Negative'
